import React from 'react'

const Backdrop = () => {
  return (
    <div id='backdrop' style={{width: '100vw', height:'100vh', position:'fixed',backgroundColor: '#1b1b1b70', zIndex: '6' }}>
      
    </div>
  )
}

export default Backdrop
